import {
    FETCH_RISK_CONFIG,
    FETCH_RISK_CONFIG_FAIL,
    FETCH_RISK_CONFIG_SUCCESS,
    RESET_RISK,
    UPDATE_RISK_CONFIG,
    UPDATE_RISK_CONFIG_FAIL,
    UPDATE_RISK_CONFIG_SUCCESS
} from './actionTypes';

export const fetchRiskConfig = args => ({
    type: FETCH_RISK_CONFIG,
    payload: args
});

export const fetchRiskConfigSuccess = response => ({
    type: FETCH_RISK_CONFIG_SUCCESS,
    payload: response
});

export const fetchRiskConfigFail = error => ({
    type: FETCH_RISK_CONFIG_FAIL,
    payload: error
});

export const updateRiskConfig = args => ({
    type: UPDATE_RISK_CONFIG,
    payload: args
});

export const updateRiskConfigSuccess = response => ({
    type: UPDATE_RISK_CONFIG_SUCCESS,
    payload: response
});

export const updateRiskConfigFail = error => ({
    type: UPDATE_RISK_CONFIG_FAIL,
    payload: error
});

export const resetRisk = () => ({
    type: RESET_RISK
});
